
export default {
	name: "AboutFeaturedOn",
	data() {
		return {
			entries: [
				{
					label: "CNBC",
					image: "/static/images/media-features/lg-cnbc@2x.jpg",
					url: "https://www.cnbc.com/2022/08/19/these-phrases-make-you-sound-passive-aggressive-in-the-workplace.html",
				},
				{
					label: "PCMag",
					image: "/static/images/media-features/logo-pcmag@2x.jpg",
					url: "https://www.pcmag.com/news/use-tinder-here-are-the-right-words-to-get-a-right-swipe",
				},
				{
					label: "Rolling Stone",
					image: "/static/images/media-features/log-rollingstone@2x.jpg",
					url: "https://www.rollingstone.de/studie-diese-rock-und-metal-lyrics-werden-am-haeufigsten-falsch-verstanden-2492353/",
				},
				{
					label: "Newsweek",
					image: "/static/images/media-features/lg-newsweek@2x.jpg",
					url: "https://www.newsweek.com/america-misspells-these-five-car-brand-names-most-1748019",
				},
				{
					label: "Teen Vogue",
					image: "/static/images/media-features/lg-teenvogue@2x.jpg",
					url: "https://www.teenvogue.com/story/how-to-celebrate-the-holidays-away-from-home",
				},
				{
					label: "Inc.com.",
					image: "/static/images/media-features/lg-inc@2x.jpg",
					url: "https://www.inc.com/minda-zetlin/business-terms-acronyms-abbreviations-confusing-most-searched.html",
				},
				{
					label: "Medium",
					image: "/static/images/media-features/lg-medium@2x.jpg",
					url: "https://jeffharryplays.medium.com/hrchat-how-your-inner-child-can-remove-workplace-toxicity-744bda4a0184",
				},
				{
					label: "Huffpost",
					image: "/static/images/media-features/lg-huffpost@2x.jpg",
					url: "https://www.huffpost.com/entry/wheel-of-fortune-declaring-victory_n_5fb304d3c5b6f79d601a2c77",
				},
				{
					label: "Psychology Today",
					image: "/static/images/media-features/lg-psychologytoday@2x.jpg",
					url: "https://www.psychologytoday.com/intl/blog/the-venn-diagram-life/202202/the-cognitive-abilities-help-you-excel-wordle",
				},
				{
					label: "Mental Floss",
					image: "/static/images/media-features/lg-mentalfloss@2x.jpg",
					url: "https://www.mentalfloss.com/article/50090/10-words-will-win-you-any-game-scrabble",
				},
			],
		};
	},
};
